import { render } from "./ApplyRefund.vue?vue&type=template&id=a2d6ecc8"
import script from "./ApplyRefund.vue?vue&type=script&lang=js"
export * from "./ApplyRefund.vue?vue&type=script&lang=js"

import "./ApplyRefund.vue?vue&type=style&index=0&id=a2d6ecc8&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__